import styled from 'styled-components';

const StyledWrapper = styled.h3`
    color: var(--color, ${({ theme }) => theme.light});
`;

export default StyledWrapper;
